import {PaginationItemSelect} from "@/theme";

export const UsersSelect = ({...rest}) => {

    const transform = (user) =>({
        label: `${user.first_name} ${user.last_name} (${user.id})`,
        value: user.id,
    })

    return(
        <PaginationItemSelect
            placeholder={'Select user'}
            requestSearchName={'name'}
            routeName={'user.all'}
            requestDataName={'user'}
            transform={transform}
            {...rest}
        />
    )
}